import { MglMap } from '@advisr/v-mapbox';
import MapService from '@/services/mapService';
import { isInternetExplorer11 } from '@/utils/vuex';
import 'mapbox-gl/dist/mapbox-gl.css';
import '@advisr/v-mapbox/dist/v-mapbox.css';
import get from 'lodash/get';
export default {
  name: 'CoreMapboxMglMap',
  components: {
    MglMap
  },
  data() {
    return {
      hideToRefresh: false
    };
  },
  computed: {
    mapAccessToken() {
      return MapService.getAccessToken();
    },
    mapStyle() {
      const light = 'mapbox://styles/mapbox/light-v9';
      const dark = 'mapbox://styles/mapbox/dark-v10';
      const dmStreets = 'mapbox://styles/digimondo/cjn4e7kzsjv8w2rlc0a574xu4';
      const satellite = 'mapbox://styles/mapbox/satellite-v9';
      const streets = 'mapbox://styles/mapbox/streets-v11';
      const queryMapStyle = parseInt(get(this.$route, 'query.mapstyle', 0), 10);
      const storeMapStyle = parseInt(get(this.$store.state.app, 'mapStyle', 0), 10);
      switch (queryMapStyle || storeMapStyle) {
        case 1:
          return !this.$store.state.app.UiTheme ? light : dark;
        case 2:
          return satellite;
        case 3:
          return streets;
        case 4:
          return dmStreets;
        default:
          return !this.$store.state.app.UiTheme ? light : dark;
      }
    },
    actualMapProps() {
      return {
        interactive: true,
        trackResize: true,
        accessToken: this.mapAccessToken,
        mapStyle: this.mapStyle,
        ...this.$attrs
      };
    },
    isInteractive() {
      return this.actualMapProps.interactive;
    }
  },
  watch: {
    'this.$store.state.app.mapStyle': {
      handler() {
        if (!this.$store.state.app.mapStyle) {
          this.$store.state.app.mapStyle = localStorage.getItem('mapStyle');
        }
      },
      immediate: true
    },
    isInteractive() {
      this.rebuildMap();
    },
    '$store.state.app.map3DBuild': {
      handler() {
        this.toggleThreeDeeLayer();
      }
    }
  },
  created() {
    // mapbox-gl-draw cannot be correctly transpiled for IE11 (actually, not at all, atm),
    // so since the map needs to work in that browser and the dependency cannot be selectively excluded,
    // instead include it dynamically on runtime here, if the browser is not IE11
    // (NOTE: "isNotIE11" will literally also be true for IE10, but in that browser nothing works anyway, so have at it.)
    if (!isInternetExplorer11() && !window.didLoadMaboxGlDrawLib) {
      const script = document.createElement('script');
      script.src = 'https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-draw/v1.0.9/mapbox-gl-draw.js';
      document.getElementsByTagName('head')[0].appendChild(script);
      const css = document.createElement('link');
      css.rel = 'stylesheet';
      css.href = 'https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-draw/v1.0.9/mapbox-gl-draw.css';
      css.type = 'text/css';
      document.getElementsByTagName('head')[0].appendChild(css);
      window.didLoadMaboxGlDrawLib = true;
    }
  },
  methods: {
    rebuildMap() {
      this.hideToRefresh = true;
      this.$nextTick(() => {
        this.hideToRefresh = false;
      });
    },
    onMapLoaded(event) {
      if (this.map) {
        this.map.remove();
      }
      const {
        map
      } = event;
      this.map = map;
      const observer = new ResizeObserver(() => {
        try {
          event.map.resize();
          this.$emit('resize');
        } catch (e) {
          console.warn('Could not resize map (observer)', e);
        }
      });
      observer.observe(map.getContainer());
      this.toggleThreeDeeLayer();
      this.$emit('load', event);
    },
    toggleThreeDeeLayer() {
      if (this.$store.state.app.map3DBuild) {
        this.addThreeDeeLayer();
      } else {
        this.removeThreeDeeLayer();
      }
    },
    addThreeDeeLayer() {
      MapService.add3DBuildingLayer(this.map);
    },
    removeThreeDeeLayer() {
      MapService.remove3DBuildingLayer(this.map);
    }
  }
};